import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { SignupService } from 'src/app/services/signup.service';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LatinCharacterService } from 'src/app/services/nonlatintolatin.service';
import { codeMaskList } from 'src/app/shared/codemasklist';
@Component({
  selector: 'dialog-changeSenderInfo',
  templateUrl: 'change-sender-info-dialog.html',
})
export class ChangeSenderInfoDialog implements OnInit, AfterViewInit {
    forbiddenCountryCodes = [
        "DZ", "AO", "BJ", "BW", "BF", "BI", "CV", "CM", "CF", "TD", "KM", "CG", "CD", "DJ", "EG", "GQ", "ER", "SZ", "ET", "GA",
        "GM", "GH", "GN", "GW", "CI", "KE", "LS", "LR", "LY", "MG", "MW", "ML", "MR", "MU", "MA", "MZ", "NA", "NE", "NG", "RW",
        "ST", "SN", "SC", "SL", "SO", "ZA", "SS", "SD", "TZ", "TG", "TN", "UG", "ZM", "ZW", "AF", "AM", "AZ", "BH", "BD", "BT",
        "BN", "KH", "CN", "CY", "GE", "IN", "ID", "IR", "IQ", "IL", "JP", "JO", "KZ", "KW", "KG", "LA", "LB", "MY", "MV", "MN",
        "MM", "NP", "KP", "OM", "PK", "PS", "PH", "QA", "SA", "SG", "KR", "LK", "SY", "TJ", "TH", "TL", "TR", "TM", "AE", "UZ",
        "VN", "YE", "AR", "BO", "BR", "CL", "CO", "EC", "GY", "PY", "PE", "SR", "UY", "VE", "HK", "TW"
      ];
    @ViewChild("senderPlacesRef") senderPlacesRef: ElementRef;
    options = {
        fields: ["address_components", "place_id"],
        types: ["address"],
    }
    formattedAddress;
    allCountries;
    changeSenderInfoForm = new UntypedFormGroup({
        senderName: new UntypedFormControl('', Validators.required),
        senderEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
        senderPhone: new UntypedFormControl('', Validators.required),
        addressLineOne: new UntypedFormControl('', Validators.required),
        addressLineTwo: new UntypedFormControl(''),
        country: new UntypedFormControl('AU', Validators.required),
        cityName: new UntypedFormControl('', Validators.required),
        state: new UntypedFormControl(''),
        postCode: new UntypedFormControl('', Validators.required),
        defaultAddress: new UntypedFormControl(false),
        company: new UntypedFormControl('', Validators.required)
    })
    testMask;
    codeMaskList = codeMaskList;

    autocomplete: google.maps.places.Autocomplete | undefined;

    token;
    userID;
    profileDetails;
    constructor(
        public dialogRef: MatDialogRef<ChangeSenderInfoDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private latinCharService: LatinCharacterService,
        private signUpService: SignupService,
        private store: Store<AppState>,
        private toastr: ToastrService
    ) { }
    ngOnInit(): void {
        this.store.select('auth').subscribe(state => {
            this.token = state.token;
            this.userID = state.user?.id;
            if (this.userID) {
                this.signUpService.getUserByUserID(this.userID, this.token).subscribe(data => {
                    this.profileDetails = data["data"];
                })
            } else{}
        })
        this.signUpService.getAllCountries().subscribe(list => {
            const filteredCountries = list['data'].filter((item) => {
                return !this.forbiddenCountryCodes.includes(item.code);
              }); 
              this.allCountries = filteredCountries;
              this.changeSenderInfoForm.controls.country.setValue(
                this.allCountries[0].code
              );
        })
        this.testMask = this.getMaskbyCountry(this.changeSenderInfoForm.value.country, this.codeMaskList);
    }

    ngAfterViewInit(): void {
        this.autocomplete = new google.maps.places.Autocomplete(
          this.senderPlacesRef.nativeElement
        );
        this.autocomplete.addListener('place_changed', () => {
          const place = this.autocomplete?.getPlace();
          if (place) {
            this.handleAddressChange(place, 'add')
          }
        });
      }

  closeWithoutAddItem(): void {
    this.changeSenderInfoForm.reset();
    this.dialogRef.close();
  }

  checkInputValidationsAddItem() {
    var hasError = false;
    if (this.changeSenderInfoForm.controls.senderName.status == 'INVALID') {
      this.changeSenderInfoForm.controls.senderName.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.senderEmail.status == 'INVALID') {
      this.changeSenderInfoForm.controls.senderEmail.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.senderPhone.status == 'INVALID') {
      this.changeSenderInfoForm.controls.senderPhone.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.addressLineOne.status == 'INVALID') {
      this.changeSenderInfoForm.controls.addressLineOne.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.addressLineTwo.status == 'INVALID') {
      this.changeSenderInfoForm.controls.addressLineTwo.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.country.status == 'INVALID') {
      this.changeSenderInfoForm.controls.country.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.cityName.status == 'INVALID') {
      this.changeSenderInfoForm.controls.cityName.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.state.status == 'INVALID') {
      this.changeSenderInfoForm.controls.state.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.postCode.status == 'INVALID') {
      this.changeSenderInfoForm.controls.postCode.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.defaultAddress.status == 'INVALID') {
      this.changeSenderInfoForm.controls.defaultAddress.markAsTouched();
      hasError = true;
    }
    return hasError;
  }
  public handleAddressChange(address: any, formType) {
    this.formattedAddress = address.formatted_address; 
    this.fillInAddress(address, formType);
  }
  fillInAddress(place, formType) {
    const addressNameFormat = {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'long_name',
      administrative_area_level_4: 'long_name',
      administrative_area_level_2: 'long_name',
      country: 'short_name',
      postal_code: 'short_name',
    };

    const componentForm = [
      'location',
      'locality',
      'administrative_area_level_1',
      'administrative_area_level_4',
      'administrative_area_level_2',
      'country',
      'postal_code',
    ];
    const getAddressComp = function (type) {
      for (const component of place.address_components) {
        if (component.types[0] === type) {
          return component[addressNameFormat[type]];
        }
      }
      return '';
    };

        var googleDBCountry = getAddressComp('country')
        var replacedCountry = "";
        if (this.forbiddenCountryCodes.includes(googleDBCountry)) {
            this.changeSenderInfoForm.reset();
            this.changeSenderInfoForm.controls.country.setValue(
              this.allCountries[0].code
            );
            return this.toastr.error('This country is not supported.');
          }
        var hasCountryInShippnDB = this.allCountries.filter(item => {
            return item.code == googleDBCountry;
        })

        if (googleDBCountry == "GB") {
            replacedCountry = "UK";
        }
        else if (hasCountryInShippnDB.length == 0) {
            replacedCountry = "";
        }
        else {
            replacedCountry = googleDBCountry;
        }

    this.changeSenderInfoForm.patchValue({
      addressLineOne:
        this.latinCharService.replaceNonLatinCharacters(
          getAddressComp('street_number')
        ) +
        ' ' +
        this.latinCharService.replaceNonLatinCharacters(
          getAddressComp('route')
        ) +
        ' ' +
        this.latinCharService.replaceNonLatinCharacters(
          getAddressComp('administrative_area_level_4')
        ),
      //addressLineTwo: address.line2,
      country: replacedCountry,
      cityName: this.latinCharService.replaceNonLatinCharacters(
        getAddressComp('administrative_area_level_2')
      ),
      state: this.latinCharService.replaceNonLatinCharacters(
        getAddressComp('administrative_area_level_1')
      ),
      postCode: getAddressComp('postal_code'),
    });
    for (const component of componentForm) {
      if (component !== 'location') {
      }
      if (component == 'postal_code') {
        this.testMask = this.getMaskbyCountry(
          replacedCountry,
          this.codeMaskList
        );
      }
    }
  }
  getMaskbyCountry(c, a) {
    for (var i = a.length - 1; i >= 0; i--) {
      if (a[i].code == c) return a[i].mask;
    }
    return '';
  }
  addNewAddress() {
    if (this.userID) {
      if (
        this.checkInputValidationsAddNewAddress() == false &&
        this.checkAddressIsUnique(this.changeSenderInfoForm) == true
      ) {
        var userData = {
          name: '',
          line1: this.latinCharService.replaceNonLatinCharacters(
            this.changeSenderInfoForm.value.addressLineOne
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                letter.toUpperCase()
              )
          ),
          line2: this.changeSenderInfoForm.value.addressLineTwo
            ? this.latinCharService.replaceNonLatinCharacters(
                this.changeSenderInfoForm.value.addressLineTwo
                  .toLowerCase()
                  .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                    letter.toUpperCase()
                  )
              )
            : '',
          country_code: this.changeSenderInfoForm.value.country,
          city_name: this.latinCharService.replaceNonLatinCharacters(
            this.changeSenderInfoForm.value.cityName
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                letter.toUpperCase()
              )
          ),
          state: this.latinCharService.replaceNonLatinCharacters(
            this.changeSenderInfoForm.value.state
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                letter.toUpperCase()
              )
          ),
          post_code: this.changeSenderInfoForm.value.postCode.toString(),
          active: this.changeSenderInfoForm.value.defaultAddress,
          full_name: this.changeSenderInfoForm.value.senderName,
          phone: this.changeSenderInfoForm.value.senderPhone,
          email: this.changeSenderInfoForm.value.senderEmail,
          company: this.changeSenderInfoForm.value.company,
        };
        this.signUpService
          .AddShopperAddress(this.token, userData)
          .subscribe((data) => {
            if (data['result']['status'] == 200) {
              this.profileDetails.addresses = data['data'];
              let senderPhoneNumber = `${this.profileDetails.phone.country_code} ${this.profileDetails.phone.phone_number}`;
              let dialogCloseResponse = {
                senderName: this.changeSenderInfoForm.value.senderName,
                senderPhone: this.changeSenderInfoForm.value.senderPhone,
                senderEmail: this.changeSenderInfoForm.value.senderEmail,
                addressLineOne: this.latinCharService.replaceNonLatinCharacters(
                  this.changeSenderInfoForm.value.addressLineOne
                    .toLowerCase()
                    .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                      letter.toUpperCase()
                    )
                ),
                addressLineTwo: this.changeSenderInfoForm.value.addressLineTwo
                  ? this.latinCharService.replaceNonLatinCharacters(
                      this.changeSenderInfoForm.value.addressLineTwo
                        .toLowerCase()
                        .replace(
                          /(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g,
                          (letter) => letter.toUpperCase()
                        )
                    )
                  : '',
                country: this.changeSenderInfoForm.value.country,
                cityName: this.latinCharService.replaceNonLatinCharacters(
                  this.changeSenderInfoForm.value.cityName
                    .toLowerCase()
                    .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                      letter.toUpperCase()
                    )
                ),
                state: this.latinCharService.replaceNonLatinCharacters(
                  this.changeSenderInfoForm.value.state
                    .toLowerCase()
                    .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                      letter.toUpperCase()
                    )
                ),
                postCode: this.changeSenderInfoForm.value.postCode,
                id: data['data'][data['data'].length - 1]['id'],
              };
              let response = {
                customSenderInfo: dialogCloseResponse,
                updatedAddresses: this.profileDetails.addresses,
              };

              this.dialogRef.close(response);
              this.changeSenderInfoForm.reset();
            } else {
              this.toastr.error(data['result']['message'], 'Error');
            }
          });
      } else {
        if (this.checkAddressIsUnique(this.changeSenderInfoForm) == false) {
          this.toastr.error(
            'This address already exists in your addresses list.'
          );
          return false;
        }
      }
    } else {
      let dialogCloseResponse = {
        senderName: this.changeSenderInfoForm.value.senderName,
        senderPhone: this.changeSenderInfoForm.value.senderPhone,
        senderEmail: this.changeSenderInfoForm.value.senderEmail,
        addressLineOne: this.latinCharService.replaceNonLatinCharacters(
          this.changeSenderInfoForm.value.addressLineOne
            .toLowerCase()
            .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
              letter.toUpperCase()
            )
        ),
        addressLineTwo: this.changeSenderInfoForm.value.addressLineTwo
          ? this.latinCharService.replaceNonLatinCharacters(
              this.changeSenderInfoForm.value.addressLineTwo
                .toLowerCase()
                .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                  letter.toUpperCase()
                )
            )
          : '',
        country: this.changeSenderInfoForm.value.country,
        cityName: this.latinCharService.replaceNonLatinCharacters(
          this.changeSenderInfoForm.value.cityName
            .toLowerCase()
            .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
              letter.toUpperCase()
            )
        ),
        state: this.latinCharService.replaceNonLatinCharacters(
          this.changeSenderInfoForm.value.state
            .toLowerCase()
            .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
              letter.toUpperCase()
            )
        ),
        postCode: this.changeSenderInfoForm.value.postCode,
        id: 0,
      };
      let response = {
        customSenderInfo: dialogCloseResponse,
        updatedAddresses: [],
      };

      this.dialogRef.close(response);
      this.changeSenderInfoForm.reset();
    }
  }
  changeAddCountry() {
    this.testMask = this.getMaskbyCountry(
      this.changeSenderInfoForm.value.country,
      this.codeMaskList
    );
  }
  changeSenderInfoToCreateShipment() {
    if (!this.checkInputValidationsAddItem()) {
      this.dialogRef.close(this.changeSenderInfoForm.value);
    }
  }
  checkInputValidationsAddNewAddress() {
    var hasError = false;
    if (this.changeSenderInfoForm.controls.senderName.status == 'INVALID') {
      this.changeSenderInfoForm.controls.senderName.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.company.status == 'INVALID') {
      this.changeSenderInfoForm.controls.company.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.senderPhone.status == 'INVALID') {
      this.changeSenderInfoForm.controls.senderPhone.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.senderEmail.status == 'INVALID') {
      this.changeSenderInfoForm.controls.senderEmail.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.addressLineOne.status == 'INVALID') {
      this.changeSenderInfoForm.controls.addressLineOne.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.country.status == 'INVALID') {
      this.changeSenderInfoForm.controls.country.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.cityName.status == 'INVALID') {
      this.changeSenderInfoForm.controls.cityName.markAsTouched();
      hasError = true;
    }
    if (this.changeSenderInfoForm.controls.postCode.status == 'INVALID') {
      this.changeSenderInfoForm.controls.postCode.markAsTouched();
      hasError = true;
    }
    return hasError;
  }
  checkAddressIsUnique(addressForm) {
    if (this.profileDetails?.addresses.length > 0) {
      let addressLine1 = this.latinCharService.replaceNonLatinCharacters(
        addressForm.value.addressLineOne
          .toLowerCase()
          .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
            letter.toUpperCase()
          )
      );
      let addressLine2 = addressForm.value.addressLineTwo
        ? this.latinCharService.replaceNonLatinCharacters(
            addressForm.value.addressLineTwo
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                letter.toUpperCase()
              )
          )
        : '';
      let postCode = addressForm.value.postCode
        .toLowerCase()
        .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
          letter.toUpperCase()
        );
      let city = this.latinCharService.replaceNonLatinCharacters(
        addressForm.value.cityName
          .toLowerCase()
          .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
            letter.toUpperCase()
          )
      );
      let state = this.latinCharService.replaceNonLatinCharacters(
        addressForm.value.state
          .toLowerCase()
          .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
            letter.toUpperCase()
          )
      );
      let userAddresses = this.profileDetails?.addresses;
      return !userAddresses.some((address) => {
        let userAdLine1 = this.latinCharService.replaceNonLatinCharacters(
          address.line1
            .toLowerCase()
            .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
              letter.toUpperCase()
            )
        );
        let userAdLine2 = address.line2
          ? this.latinCharService.replaceNonLatinCharacters(
              address.line2
                .toLowerCase()
                .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
                  letter.toUpperCase()
                )
            )
          : '';
        let userAdPostCode = this.latinCharService.replaceNonLatinCharacters(
          address.post_code
            .toLowerCase()
            .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
              letter.toUpperCase()
            )
        );
        let userAdCity = this.latinCharService.replaceNonLatinCharacters(
          address.city_name
            .toLowerCase()
            .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
              letter.toUpperCase()
            )
        );
        let userAdState = this.latinCharService.replaceNonLatinCharacters(
          address.state
            .toLowerCase()
            .replace(/(^\w{1})|(\s+\w{1})|(\b[a-z](?!\b))/g, (letter) =>
              letter.toUpperCase()
            )
        );
        return (
          userAdLine1 == addressLine1 &&
          userAdLine2 == addressLine2 &&
          postCode == userAdPostCode &&
          city == userAdCity &&
          state == userAdState
        );
      });
    } else {
      return true;
    }
  }
}
